import {Region, REGIONS, StateUtils, UserActions} from '@spartacus/core';
import {CustomRegions} from '../actions';
import {ActionReducerMap} from '@ngrx/store';
import {OrderStatusList, StateOrderStatusList} from '../../../../model/order-status-list.model';
import {InjectionToken} from '@angular/core';
import {RegionsState} from '../selectors/regions-zone.selectors';


export const initialState: RegionsState = {
  entities: [],
  country: null,
  zone: null,
};

export function reducer(
  state = initialState,
  action: CustomRegions.CustomRegionsAction | UserActions.ClearUserMiscsData
): RegionsState {
  switch (action.type) {
    case CustomRegions.LOAD_REGIONS_SUCCESS: {
      const entities: Region[] = action.payload.entities;
      const country: string = action.payload.country;
      const zone: string = action.payload.zone;
      if (entities || country) {
        return {
          ...state,
          entities,
          country,
          zone,
        };
      }
      return initialState;
    }
  }

  return state;
}

export interface UserRegionState{
  regions: StateUtils.LoaderState<RegionsState>;
}

export const USER_REGION_ZONE = 'user-zone';

export interface StateWithUserRegionState {
  [USER_REGION_ZONE]: UserRegionState;
}

export function getReducers(): ActionReducerMap<UserRegionState> {
  return {
    regions: StateUtils.loaderReducer<RegionsState>(REGIONS, reducer),
  };
}

export const reducerRegionsByZoneToken: InjectionToken<ActionReducerMap<StateWithUserRegionState>> =
  new InjectionToken<ActionReducerMap<UserRegionState>>('RegionsByZoneReducer');

export const reducerRegionsByZoneProvider = {
  provide: reducerRegionsByZoneToken,
  useFactory: getReducers,
};

